import React, { useState } from 'react';
import styles from './serviceBoxs.module.scss';
import ServiceCard from '../ServiceCard';
import ServiceFormModal from '../ServiceFormModal';
import { images } from '../../constants/images';
import { useNavigate } from 'react-router-dom';

interface ServiceBoxsProps {
  onIcarClick?: ((formData?: any, brand?: any) => void);
  onMokClick?: ((formData: any, brand?: any) => void);
  onMaviClick?: ((formData: any, brand?: any) => void);
  onFullMecClick?: ((formData: any, brand?: any) => void);
  onHDIClick?: ((formData: any, brand?: any) => void);
  onIcarTagClick?: ((formData: any, brand?: any) => void);
  user?: any;
  setLoginRedirection?: any;
  vehicleTypeSelected?: string;
  brand?: any;
  type?: string;
}

const ServiceBoxs: React.FC<ServiceBoxsProps> = ({ 
  onIcarClick, 
  onMokClick, 
  onMaviClick, 
  onFullMecClick,
  onHDIClick,
  onIcarTagClick,
  user,
  setLoginRedirection,
  vehicleTypeSelected,
  brand,
  type
}) => {
  const [mokModalOpen, setMokModalOpen] = useState(false);
  const [fullMecModalOpen, setFullMecModalOpen] = useState(false);
  const [maviModalOpen, setMaviModalOpen] = useState(false);
  const [icarModalOpen, setIcarModalOpen] = useState(false);
  const [hdiModalOpen, setHDIModalOpen] = useState(false);
  const [icarTagModalOpen, setIcarTagModalOpen] = useState(false);
  const navigate = useNavigate();
  
  const handleMokClick = () => {
    setMokModalOpen(true);
  };
  
  const handleFullMecClick = () => {
    setFullMecModalOpen(true);
  };

  const handleMaviClick = () => {
    setMaviModalOpen(true);
  };

  const handleHDIClickLocal = () => {
    setHDIModalOpen(true);
  };

  const handleServicesClick = () => {
    navigate('/servicios');
  };

  const handleTagClickLocal = () => {
    setIcarTagModalOpen(true);
  };
  
  const handleSubmitTag = (formData: any, brand: any) => {
    if (onIcarTagClick) {
      onIcarTagClick(formData, brand);
    }
  };
  
  const handleSubmitMok = (formData: any, brand: any) => {
    if (onMokClick) {
      onMokClick(formData, brand);
    }
  };
  
  const handleSubmitFullMec = (formData: any, brand: any) => {
    if (onFullMecClick) {
      onFullMecClick(formData, brand);
    }
  };

  const handleSubmitMavi = (formData: any, brand: any) => {
    if (onMaviClick) {
      onMaviClick(formData, brand);
    }
  };

  const handleSubmitIcar = (formData: any, brand: any) => {
    if (onIcarClick) {
      onIcarClick(formData, brand);
    }
  };

  const handleSubmitHDI = (formData: any, brand: any) => {
    if (onHDIClick) {
      onHDIClick(formData, brand);
    }
  };

  const handleLinzeClick = () => {
    console.log('LinzeClick');
  };;

  const services = [
    {
      logo: images.iCarLogoService,
      title: 'Adquiere informe',
      description: 'y verifica el historial, pide el TAG o la transferencia',
      buttonText: 'Quiero el informe',
      onClick: onIcarClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.mokLogoService,
      title: 'Solicita garantía',
      description: 'y obtén respaldo frente a desperfectos del auto',
      buttonText: 'Quiero la garantía',
      onClick: handleMokClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.maviLogoService,
      title: 'Viaja acompañado',
      description: 'del GPS al copiloto, la nueva forma de viajar',
      buttonText: 'Quiero mi copiloto',
      onClick: handleMaviClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.fullmecLogoService,
      title: 'Solicita inspección',
      description: 'y chequea el estado real de este vehículo',
      buttonText: 'Quiero la inspección',
      onClick: handleFullMecClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    }
  ];

  const servicesNew = [
    {
      logo: images.iCarLogoService,
      title: 'Adquiere tu TAG',
      description: 'y disfruta la comodidad de circular sin efectivo',
      buttonText: 'Quiero mi TAG',
      onClick: handleTagClickLocal,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.maviLogoService,
      title: 'Viaja acompañado',
      description: 'del GPS al copiloto, la nueva forma de viajar',
      buttonText: 'Quiero mi copiloto',
      onClick: handleMaviClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.linzeLogoService,
      title: 'Asegura tu auto',
      description: 'y elige la protección que mejor se adapta a ti',
      buttonText: 'Quiero un seguro',
      onClick: handleHDIClickLocal,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    },
    {
      logo: images.linzeLogoService,
      title: 'Y más',
      description: 'conoce todos los servicios que tenemos',
      buttonText: 'Ver todos',
      onClick: handleServicesClick,
      disabled: type === 'salePost' || type === 'myPublication' ? true : false
    }
  ];

  return (
    <>
      <div className={styles.serviceBoxsContainer}>
        {vehicleTypeSelected === "new" ? servicesNew.map((service, index) => (
          <div className={styles.cardWrapper} key={index}>
            <ServiceCard
              logo={service.logo}
              title={service.title}
              description={service.description}
              buttonText={service.buttonText}
              onClick={service.onClick}
              disabled={service.disabled}
            />
          </div>
        )) : services.map((service, index) => (
          <div className={styles.cardWrapper} key={index}>
            <ServiceCard
              logo={service.logo}
              title={service.title}
              description={service.description}
              buttonText={service.buttonText}
              onClick={service.onClick}
              disabled={service.disabled}
            />
          </div>
        ))}
      </div>

      <ServiceFormModal
        open={icarTagModalOpen}
        onClose={() => setIcarTagModalOpen(false)}
        title="Solicitar TAG"
        description="Completa tus datos para que podamos contactarte y contarte más sobre este servicio"
        onSubmit={handleSubmitTag}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />
      
      <ServiceFormModal
        open={mokModalOpen}
        onClose={() => setMokModalOpen(false)}
        title="Solicitar una garantía"
        description="Completa tus datos para que podamos contactarte y conversar sobre la garantía de tu próximo nuevo auto"
        onSubmit={handleSubmitMok}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />
      
      <ServiceFormModal
        open={fullMecModalOpen}
        onClose={() => setFullMecModalOpen(false)}
        title="Solicitar una inspección"
        description="Completa tus datos para que podamos contactarte y agendar la inspección de este auto"
        onSubmit={handleSubmitFullMec}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />

      <ServiceFormModal
        open={maviModalOpen}
        onClose={() => setMaviModalOpen(false)}
        title="Consultar los planes de GPS"
        description="Completa tus datos para que podamos contactarte y ofrecerte el plan que mejor se adapta a ti"
        onSubmit={handleSubmitMavi}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />

      <ServiceFormModal
        open={icarModalOpen}
        onClose={() => setIcarModalOpen(false)}
        title="Solicitar informe ICAR"
        description="Completa tus datos para que podamos contactarte y enviarte el informe de este vehículo"
        onSubmit={handleSubmitIcar}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />

      <ServiceFormModal
        open={hdiModalOpen}
        onClose={() => setHDIModalOpen(false)}
        title="Asegurar mi auto"
        description="Completa tus datos para que podamos contactarte y ofrecerte el mejor paquete para tu auto"
        onSubmit={handleSubmitHDI}
        user={user}
        setLoginRedirection={setLoginRedirection}
        brand={brand}
      />
    </>
  );
};

export default ServiceBoxs;
